The response from the `verifyCandidate` mutation.
